import {
  breadcrumbsReducer,
  notificationsReducer,
  userReducer,
} from '@prometheus/redux';
import { AnyAction, combineReducers, Reducer } from 'redux';

const rootReducer = combineReducers({
  user: userReducer,
  breadcrumbs: breadcrumbsReducer,
  notifications: notificationsReducer,
});

export default rootReducer;
